import { cn } from '@/lib/utils';

type SetuOSLogoProps = {
  /** framed = white plaque for dark backgrounds; plain = sits on cream/white pages */
  framed?: boolean;
  className?: string;
};

const LOGO_SRC = '/brand/setuos-logo-horizontal.png';

/** Official SetuOS horizontal lockup — same asset on both login panels. */
export function SetuOSLogo({ framed = false, className }: SetuOSLogoProps) {
  const image = (
    <img
      src={LOGO_SRC}
      alt="SetuOS — Connecting care. Transforming healthcare."
      className={cn('h-auto w-full object-contain', className)}
      draggable={false}
    />
  );

  if (!framed) {
    return image;
  }

  return (
    <div
      className={cn(
        'rounded-[1.75rem] bg-white px-7 py-6 shadow-[0_24px_64px_rgba(0,0,0,0.32)] ring-1 ring-white/30 sm:px-9 sm:py-7',
        className
      )}
    >
      {image}
    </div>
  );
}

export const SETUOS_LOGO_HORIZONTAL_SRC = LOGO_SRC;
